export const DELIVERY_SIZES = {
  MINI_SIZE: 60,
  MEDIUM_SIZE: 80,
  LARGE_SIZE: 100,
  EXTRA_SIZE: 120,
};
